import { Loader } from '@grafikr/components';

import regions from 'framework/regions';

export default Loader(async (_, load) => {
  const getCurrentSite = regions.getCurrentSite();
  const [shouldShowPrompt, getIntendedSite] = await Promise.all([
    regions.shouldShowPrompt(),
    regions.getIntendedSite(),
  ]);

  if (shouldShowPrompt && !regions.isSameSite(getCurrentSite, getIntendedSite)) {
    load();
  }
});
